(() => {
  'use strict';

  const VERSION = '2026-07-14-v2';
  const ROUTINES = {
    'clear-balanced-skin-routine': {
      goal: 'A focused 3-step routine for blemish-prone skin.',
      count: 3,
      regular: '109.85',
      price: '99.95',
      saving: '9.90',
    },
    'firm-smooth-skin-routine': {
      goal: 'A complete 5-step routine for mature skin.',
      count: 5,
      regular: '184.75',
      price: '159.95',
      saving: '24.80',
    },
    'combination-skin-balance-routine': {
      goal: 'A balanced 3-step routine for combination skin.',
      count: 3,
      regular: '99.85',
      price: '89.95',
      saving: '9.90',
    },
    'dry-dehydrated-skin-routine': {
      goal: 'A nourishing 5-step routine for dry and dehydrated skin.',
      count: 5,
      regular: '164.75',
      price: '144.95',
      saving: '19.80',
    },
    'glow-radiance-routine': {
      goal: 'A glow-focused 4-step routine for dull-looking skin.',
      count: 4,
      regular: '134.80',
      price: '124.95',
      saving: '9.85',
    },
    'normal-balanced-skin-routine': {
      goal: 'A balanced 3-step daily routine for normal skin.',
      count: 3,
      regular: '89.85',
      price: '79.95',
      saving: '9.90',
    },
    'sensitive-reactive-skin-routine': {
      goal: 'A hydration-focused 5-step routine to introduce gradually.',
      count: 5,
      regular: '164.75',
      price: '144.95',
      saving: '19.80',
      caution: 'The included facial oil contains fragrance and sweet almond oil.',
    },
    'simple-acne-routine': {
      goal: 'A simple 2-step cleansing and moisturising routine for blemish-prone skin.',
      count: 2,
      regular: '74.90',
      price: '69.95',
      saving: '4.95',
    },
    'simple-aging-skin-routine': {
      goal: 'A simple 2-step routine for mature skin.',
      count: 2,
      regular: '64.90',
      price: '59.95',
      saving: '4.95',
    },
    'simple-combination-skin-routine': {
      goal: 'A lightweight 2-step routine for combination skin.',
      count: 2,
      regular: '74.90',
      price: '69.95',
      saving: '4.95',
    },
    'simple-dull-skin-routine': {
      goal: 'A simple 2-step cleansing and moisturising routine for dull-looking skin.',
      count: 2,
      regular: '64.90',
      price: '59.95',
      saving: '4.95',
    },
    'simple-daily-skincare-routine': {
      goal: 'A simple 2-step daily routine for normal skin.',
      count: 2,
      regular: '64.90',
      price: '59.95',
      saving: '4.95',
    },
    'simple-oily-skin-routine': {
      goal: 'A lightweight 2-step routine for oily skin.',
      count: 2,
      regular: '74.90',
      price: '69.95',
      saving: '4.95',
    },
    'simple-sensitive-skin-routine': {
      goal: 'A simple 2-step routine designed to be introduced gradually.',
      count: 2,
      regular: '64.90',
      price: '59.95',
      saving: '4.95',
    },
  };

  const NAME_REPLACEMENTS = [
    [/Clear & Balanced Skin Routine/g, 'Acne Skin Routine'],
    [/Firm & Smooth Skin Routine/g, 'Aging Skin Routine'],
    [/Combination Skin Balance Routine/g, 'Combination Skin Routine'],
    [/Dry & Dehydrated Skin Routine/g, 'Dry Skin Routine'],
    [/Glow & Radiance Routine/g, 'Dull Skin Routine'],
    [/Normal & Balanced Skin Routine/g, 'Normal Skin Routine'],
    [/Sensitive & Reactive Skin Routine/g, 'Sensitive Skin Routine'],
    [/Simple Daily Skincare Routine/g, 'Simple Normal Skin Routine'],
  ];

  const getHandle = () => window.location.pathname.replace(/\/+$/, '').split('/').pop() || '';

  const replaceTextNodes = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      let value = node.nodeValue || '';
      NAME_REPLACEMENTS.forEach(([pattern, replacement]) => {
        value = value.replace(pattern, replacement);
      });
      if (value !== node.nodeValue) node.nodeValue = value;
    });
  };

  const addStyles = () => {
    if (document.getElementById('sovah-routine-summary-styles')) return;
    const style = document.createElement('style');
    style.id = 'sovah-routine-summary-styles';
    style.textContent = `
      .sovah-routine-summary {
        margin: 1rem 0;
        padding: 1rem;
        border: 1px solid color-mix(in srgb, currentColor 16%, transparent);
        border-radius: 0.9rem;
      }
      .sovah-routine-summary__eyebrow {
        margin: 0 0 0.35rem;
        font-size: 0.72rem;
        font-weight: 700;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        opacity: 0.72;
      }
      .sovah-routine-summary__goal {
        margin: 0 0 0.85rem;
        font-size: 1rem;
        line-height: 1.45;
      }
      .sovah-routine-summary__stats {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 0.5rem;
        margin-bottom: 0.8rem;
      }
      .sovah-routine-summary__stat {
        padding: 0.65rem 0.45rem;
        border-radius: 0.65rem;
        text-align: center;
        background: color-mix(in srgb, currentColor 5%, transparent);
      }
      .sovah-routine-summary__stat strong,
      .sovah-routine-summary__stat span {
        display: block;
      }
      .sovah-routine-summary__stat strong {
        font-size: 1rem;
        line-height: 1.2;
      }
      .sovah-routine-summary__stat span {
        margin-top: 0.15rem;
        font-size: 0.72rem;
        opacity: 0.72;
      }
      .sovah-routine-summary__pricing {
        display: flex;
        flex-wrap: wrap;
        gap: 0.35rem 0.9rem;
        margin: 0;
        font-size: 0.88rem;
      }
      .sovah-routine-summary__pricing span:first-child {
        text-decoration: line-through;
        opacity: 0.7;
      }
      .sovah-routine-summary__note,
      .sovah-routine-summary__caution {
        margin: 0.65rem 0 0;
        font-size: 0.78rem;
        line-height: 1.45;
        opacity: 0.78;
      }
      .sovah-routine-summary__caution {
        font-weight: 600;
        opacity: 0.9;
      }
      @media (max-width: 480px) {
        .sovah-routine-summary {
          padding: 0.9rem;
        }
        .sovah-routine-summary__stat {
          padding-inline: 0.3rem;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const createSummary = (routine) => {
    const section = document.createElement('section');
    section.id = 'sovah-routine-summary';
    section.className = 'sovah-routine-summary';
    section.dataset.version = VERSION;
    section.setAttribute('aria-label', 'Routine overview');
    section.innerHTML = `
      <p class="sovah-routine-summary__eyebrow">Routine overview</p>
      <p class="sovah-routine-summary__goal">${routine.goal}</p>
      <div class="sovah-routine-summary__stats">
        <div class="sovah-routine-summary__stat"><strong>${routine.count}</strong><span>products</span></div>
        <div class="sovah-routine-summary__stat"><strong>€${routine.saving}</strong><span>you save</span></div>
        <div class="sovah-routine-summary__stat"><strong>AM + PM</strong><span>daily routine</span></div>
      </div>
      <p class="sovah-routine-summary__pricing"><span>Worth €${routine.regular}</span><strong>Set price €${routine.price}</strong></p>
      ${routine.caution ? `<p class="sovah-routine-summary__caution">${routine.caution}</p>` : ''}
      <p class="sovah-routine-summary__note">Sunscreen is sold separately and is not included in this routine.</p>
    `;
    return section;
  };

  const findPrimaryProductForm = () => {
    const forms = [...document.querySelectorAll('main form[action*="/cart/add"]')];
    return forms.find((form) => form.querySelector('input[name="id"]') && form.offsetParent !== null)
      || forms.find((form) => form.querySelector('input[name="id"]'))
      || null;
  };

  const insertSummary = (routine) => {
    const existing = document.getElementById('sovah-routine-summary');
    if (existing?.dataset.version === VERSION) return;
    existing?.remove();

    const summary = createSummary(routine);
    const form = findPrimaryProductForm();
    if (form?.parentElement) {
      form.parentElement.insertBefore(summary, form);
      return;
    }

    const firstAccordion = document.querySelector('main details[data-testid="accordion-details"]');
    if (firstAccordion?.parentElement) {
      firstAccordion.parentElement.insertBefore(summary, firstAccordion);
    }
  };

  let applying = false;
  const apply = () => {
    if (applying || !window.location.pathname.includes('/products/')) return;
    const routine = ROUTINES[getHandle()];
    if (!routine) return;

    applying = true;
    try {
      const main = document.querySelector('main');
      if (!main) return;
      addStyles();
      replaceTextNodes(main);
      insertSummary(routine);
    } finally {
      applying = false;
    }
  };

  let timer;
  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(apply, 80);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
